import styled, {keyframes} from "styled-components";

export const ChoosePlansMenuContainer = styled.div`
  display: flex;
  flex: 1;
  width: 92%;
  justify-content: center;
  align-items: center;
`

export const ChoosePlansNavigationIcon = styled.i`
  color: white;
  font-size: 15vh;
  cursor: pointer;

  &:hover {
    color: #FFC4CE;
  }

  @media (max-width: 800px) {
    font-size: 10vw;
  }
`

export const ChoosePlansSelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
  margin: 0 5%;

  @media (max-width: 800px) {
    margin: 0 3%;
  }
`

export const ChoosePlansDropdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content; // makes width adjust to size of children
  cursor: pointer;
  color: white;
  user-select: none; // makes it unhighlightable
  position: relative;
`

export const ChoosePlansDropdownText = styled.p`
  font-size: 4vh;
  font-weight: 700;

  @media (max-width: 600px) {
    font-size: 20px;
  }
`

interface DropdownIconProps {
  dropdownActive: boolean
}

export const ChoosePlansDropdownIcon = styled.i<DropdownIconProps>`
  font-size: 3vh;
  margin: 4px 0 0 8px;
  transform: ${props => props.dropdownActive ? 'rotate(180deg)' : ''};
  transition: transform 500ms;

  @media (max-width: 600px) {
    font-size: 20px;
  }
`

export const ChoosePlansDropdownListKeyframes = keyframes`
  0% {
    transform: scaleY(0)
  }
  80% {
    transform: scaleY(1.1)
  }
  100% {
    transform: scaleY(1)
  }
`

export const ChoosePlansDropdownList = styled.ul<DropdownIconProps>`
  position: absolute;
  top: 5vh;
  width: 200px;
  background-color: #3f507a;
  display: ${props => props.dropdownActive ? 'initial' : 'none'};
  animation: ${ChoosePlansDropdownListKeyframes} 400ms ease-in-out forwards;
  transform-origin: top center;
  list-style: none;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  overflow: hidden;
  z-index: 3;
  
  @media (max-width: 900px){
    width: 175px;
  }
  
  @media (max-width: 600px){
    width: 100px;
  }
`

export const ChoosePlansDropdownItem = styled.li`
  font-size: 2vh;
  padding: 10px;
  
  &:hover {
    background-color: #FC496B;
  }
  
  @media (max-width: 800px){
    font-size: 16px;
  }
`

export const ChoosePlansCards = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  background-color: #2E3A59;
  border-radius: 30px;
  margin: 20px 0;
`

export const ChoosePlansCardsHeadersContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  margin-top: 30px;
  row-gap: 10px;
`

export const ChoosePlansCardsHeader = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: white;

  @media (max-width: 1000px) {
    font-size: 18px;
  }

  @media (max-width: 650px) {
    font-size: 12px;
  }
`

export const ChoosePlansCardsSubText = styled.h4`
  font-size: 14px;
  font-weight: 400;
  color: white;

  @media (max-width: 1000px) {
    font-size: 12px;
  }

  @media (max-width: 650px) {
    font-size: 8px;
  }
`

export const ChooesPlansCardsCarousel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`
